import { render, staticRenderFns } from "./MyTagList.vue?vue&type=template&id=5936a29d"
import script from "./MyTagList.vue?vue&type=script&lang=js"
export * from "./MyTagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports